export default "__VITE_ASSET__2P$ExJhD__"